import * as React from 'react';
export var CardBody = function (_a) {
    var children = _a.children;
    return <div className='p-4'>{children}</div>;
};
CardBody.displayName = 'UI.Card.CardBody';
